"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeProjection = void 0;
const class_transformer_1 = require("class-transformer");
const makeProjection = (modelCtor) => {
    return Object.getOwnPropertyNames(class_transformer_1.classToPlain(new modelCtor())).reduce((p, k) => {
        p[k] = 1;
        return p;
    }, {});
};
exports.makeProjection = makeProjection;
//# sourceMappingURL=projection.js.map